export default __webpack_public_path__ + "static/media/no-result.2e22a4d0.svg";